import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Ticket } from '@app/models/ticket.model';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AppService } from '@app/app.service';

@Component({
  selector: 'app-ticket-view-dialog',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './ticket-view-dialog.component.html',
  styleUrl: './ticket-view-dialog.component.scss',
})
export class TicketViewDialogComponent {

  form;

  constructor(
    public dialogRef: MatDialogRef<TicketViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public ticket: Ticket,
    private fb: FormBuilder,
    private appService: AppService,
  ) {
    this.form = this.fb.group({
      admin_response: ['', [Validators.required, Validators.maxLength(5000)]],
    });
  }

  resolveTicket(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.appService.showSnackBar('Admin response is required', 'error');
      return;
    }

    this.appService.resolveTicket(this.ticket.id, this.form.value).subscribe({
      next: () => {
        this.appService.showSnackBar('Ticket resolved successfully', 'success');
        this.dialogRef.close(true);
      },
      error: () => {
        this.appService.showSnackBar('Failed to resolve ticket', 'error');
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}